import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Switch, Button, Space } from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';
import {
  createRbacAction,
  updateRbacAction
} from '../../redux/actions/rbacActions';

const ActionForm = ({ onCancel }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { editing, actionsLoading } = useSelector(state => state.rbac);

  useEffect(() => {
    if (editing) {
      form.setFieldsValue({
        action: editing.action,
        display_name: editing.display_name,
        type: editing.type,
        enable: editing.enable === 1,
      });
    } else {
      form.resetFields();
    }
  }, [editing, form]);

  const handleSubmit = (values) => {
    const formData = {
      action: values.action,
      display_name: values.display_name,
      type: values.type,
      enable: values.enable ? 1 : 0,
    };

    if (editing) {
      dispatch(updateRbacAction(editing.id, formData));
    } else {
      dispatch(createRbacAction(formData));
    }
    
    onCancel();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={{
        enable: true,
      }}
    >
      <Form.Item
        label="Action"
        name="action"
        rules={[
          { required: true, message: 'Please enter action identifier' },
          { 
            pattern: /^[a-z_]+\/[a-z_]+$/,
            message: 'Action must be in format: module/operation (e.g., vendor/create)'
          }
        ]}
        tooltip="Format: module/operation (e.g., vendor/view, product/create)"
      >
        <Input 
          placeholder="e.g., report/export" 
          size="large"
          disabled={editing ? true : false}
        />
      </Form.Item>

      <Form.Item
        label="Display Name"
        name="display_name"
        rules={[
          { required: true, message: 'Please enter display name' },
          { min: 2, message: 'Display name must be at least 2 characters' }
        ]}
      >
        <Input placeholder="e.g., Export Reports" size="large" />
      </Form.Item>

      <Form.Item
        label="Type/Module"
        name="type"
        rules={[
          { required: true, message: 'Please enter type/module name' },
          { 
            pattern: /^[a-z_]+$/,
            message: 'Type must contain only lowercase letters and underscores'
          }
        ]}
        tooltip="Module or category name (e.g., vendor, product, report)"
      >
        <Input placeholder="e.g., report" size="large" />
      </Form.Item>

      <Form.Item
        label="Enable"
        name="enable"
        valuePropName="checked"
        extra="When disabled, this action cannot be assigned as a permission"
      >
        <Switch checkedChildren="Enabled" unCheckedChildren="Disabled" />
      </Form.Item>

      <Form.Item style={{ marginBottom: 0, marginTop: '2rem' }}>
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button onClick={onCancel} icon={<CloseOutlined />}>
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={actionsLoading}
            icon={<SaveOutlined />}
          >
            {editing ? 'Update Action' : 'Create Action'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ActionForm;
